import CreatePage from './CreatePage';
import EditPage from './EditPage';
import DetailsPage from './DetailsPage';
import ListPage from './ListPage.container';

export default {
  CreatePage,
  EditPage,
  DetailsPage,
  ListPage
};
